export const ONBOARDING_STORAGE_KEY = 'chest_onboarding_data';

export const getOnboardingData = () => {
  try {
    const data = localStorage.getItem(ONBOARDING_STORAGE_KEY);
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error('Error reading onboarding data from localStorage:', error);
    return null;
  }
};

export const setOnboardingData = (data) => {
  try {
    localStorage.setItem(ONBOARDING_STORAGE_KEY, JSON.stringify(data));
    return true;
  } catch (error) {
    console.error('Error saving onboarding data to localStorage:', error);
    return false;
  }
};

export const hasSeenOnboarding = () => {
  const data = getOnboardingData();
  return data?.seen || false;
};

export const markOnboardingAsSeen = (userId = null, email = null) => {
  const sessionId = generateSessionId();
  const onboardingData = {
    seen: true,
    timestamp: new Date().toISOString(),
    userId,
    email,
    sessionId,
    userType: userId ? 'registered' : 'anonymous',
    completedSteps: [1, 2, 3],
    completed: true
  };
  
  return setOnboardingData(onboardingData);
};

export const trackOnboardingStep = (step, userId = null, email = null) => {
  const sessionId = generateSessionId();
  const existingData = getOnboardingData() || {};
  const completedSteps = existingData.completedSteps || [];
  
  if (!completedSteps.includes(step)) {
    completedSteps.push(step);
  }
  
  const onboardingData = {
    ...existingData,
    timestamp: new Date().toISOString(),
    userId,
    email,
    sessionId,
    userType: userId ? 'registered' : 'anonymous',
    completedSteps,
    completed: completedSteps.length === 3
  };
  
  return setOnboardingData(onboardingData);
};

export const clearOnboardingData = () => {
  try {
    localStorage.removeItem(ONBOARDING_STORAGE_KEY);
    return true;
  } catch (error) {
    console.error('Error clearing onboarding data from localStorage:', error);
    return false;
  }
};

export const generateSessionId = () => {
  return `session_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
};

export const getOnboardingDataForBackend = () => {
  const data = getOnboardingData();
  if (!data) return null;
  
  return {
    userId: data.userId || null,
    email: data.email || null,
    sessionId: data.sessionId,
    timestamp: data.timestamp,
    userType: data.userType,
    completedSteps: data.completedSteps || [],
    completed: data.completed || false
  };
};